<template>
  <div>
    <div class="mb-2">
      <slot name="left-upper-table">

      </slot>
    </div>
    <div style="overflow-x: auto">
    <b-table v-bind="props"
             ref="b-table"
             :items="Array.isArray(items) ? items : itemsViaFunction"
             v-on="listeners"
             :show-empty="showEmpty" :empty-text="emptyText"
             :current-page="currentPage" :per-page="computedPerPage"
             :aria-busy="true"
             :busy="busy || isPageChangedBusy"
             :sort-compare="sortCompare || defaultSortCompare"
             :tbody-tr-class="rowClass"
             sort-null-last>

      <template v-for="field in fields" v-slot:[`cell(`+field.key+`)`]="data">
        <slot :name="'cell('+field.key+')'" v-bind="data">{{ data.value }}</slot>
      </template>
      <template v-for="field in fields" v-slot:[`head(`+field.key+`)`]="data">
        <slot :name="'head('+field.key+')'" v-bind="data">{{ data.label }}</slot>
      </template>

    </b-table>
    </div>

    <b-row>
      <div class="col-2">
      </div>
      <div class="col-8">
        <b-pagination :total-rows="totalRows" :per-page="computedPerPage" v-model="paginationPage"
                      prev-text=" " next-text=" "
                      first-text=" " last-text=" "
                      first-class="gap-table-nav-button gap-table-first-button"
                      prev-class="gap-table-nav-button gap-table-prev-button"
                      next-class="gap-table-nav-button gap-table-next-button"
                      last-class="gap-table-nav-button gap-table-last-button"
                      limit=10
                      @change="pageChanged" align="center">
        </b-pagination>
      </div>

      <div class="col-2 position-relative">
        <b-input-group
          class="gap-table-default-pagination-select"
          v-if="perPageVisible">
          <b-form-select :options="perPageOptions" v-model="perPageSelect" class="w-auto"
                         @change="reset(1)">

          </b-form-select>
        </b-input-group>
      </div>
    </b-row>

  </div>
</template>

<script>

  import {gapDefaultSort} from "@/util/sort";

  export default {
    name: "GapTable",
    props: {
      fields: {
        type: Array,
        default: null
      },
      items: {
        type: [Array, Function]
      },
      perPageVisible: {
        type: Boolean,
        default: true
      },
      perPage: {
        default: -1
      },
      primaryKey: {
        type: String,
        default: ""
      },
      emptyText: {
        type: String,
        default: "검색결과가 없습니다."
      },
      showEmpty: {
        type: Boolean,
        default: false
      },
      busy: {
        type: Boolean,
        default: false
      },
      sortCompare: {
        type: Function,
        default: null
      },
      rowClass: {
        type: Function,
        default: null
      }
    },
    data() {
      return {
        itemsViaFunction: [],
        paginationPage: 1,
        totalRows: 0,
        isPageChangedBusy: false,
        getItemsFunction: null,
        perPageOptions: [
          {text: "10개씩", value: 10},
          {text: "30개씩", value: 30},
          {text: "50개씩", value: 50},
          {text: "100개씩", value: 100}],
        perPageSelect: 10
      }
    },
    async mounted() {
      this.pageChanged(this.currentPage);
    },
    methods: {
      reset(page=1) {
        this.pageChanged(page);
      },
      async pageChanged(page) {
        this.isPageChangedBusy = true;
        this.paginationPage = page < 1 ? 1 : page;
        if (!this.items) {
          this.itemsViaFunction = [];
          this.totalRows = 0;
        } else if (Array.isArray(this.items)) {
          this.itemsViaFunction = this.items;
          this.totalRows = this.items.length;
        } else {
          const funcResult = await this.items(page - 1, this.computedPerPage);
          console.log(funcResult);
          if (Array.isArray(funcResult)) {      //어레이다
            this.itemsViaFunction = funcResult;
            this.totalRows = funcResult.length;
          } else if (funcResult.data &&
                     (funcResult.data.content || funcResult.data.data)) {   //data, content가 있다 -> @RestContoller api Collection의 결과를 바로 받은 것. content가 있으면 Page<T>등등
            const data = funcResult.data;
            this.itemsViaFunction = data?.data?.content || data.data;
            this.totalRows = data?.data?.totalElements;
          } else {                                            //어레이도 아니고 data 또는 content 없다 -> 빈 배열
            this.itemsViaFunction = [];
            this.totalRows = 0;
          }
        }
        this.isPageChangedBusy = false;
      },
      rowClicked(item) {
        this.$emit('row-clicked', item);
      },
      defaultSortCompare(aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {

        let a = aRow;
        let b = bRow;

        key.split('.').forEach(key => {
          a = a != null ? a[key] : null;
          b = b != null ? b[key] : null;
        });

        if (
          (typeof a === 'number' && typeof b === 'number') ||
          (a instanceof Date && b instanceof Date)
        ) {
          return a < b ? -1 : a > b ? 1 : 0
        } else {
          return gapDefaultSort(a, b);
        }
      },
      async cleanRows() {
        this.itemsViaFunction = [];
        this.totalRows = 0;
      }
    },
    computed: {
      currentPage() {
        if (Array.isArray(this.items)) {
          return this.paginationPage;
        } else {
          return 1;
        }
      },
      computedPerPage() {
        if (this.perPage < 0) {
          return this.perPageSelect;
        } else {
          return this.perPage;
        }
      },
      props() {
        return {...this.$attrs, ...this.$props};
      },
      listeners() {
        return this.$listeners;
      }
    },
    watch: {
      items: {
        handler(newVal, oldVal) {
          if (newVal !== oldVal && Array.isArray(newVal)) {
            this.pageChanged(1);
          }
        },
        deep: true
      }
    }
  }
</script>

<style>

  .gap-table-default-pagination-select {
    width: auto;
    right: 15px;
    position: absolute;
  }

  .gap-table-default-pagination-select > .custom-select {
    border: 0;
  }

  .table > tbody > tr.b-table-row-selected {
    background: linear-gradient(
      white 5%, #fffae5 10%, #fffae5 90%, white 95%
    );
  }

  .table > tbody > tr.b-table-row-warned {
    background: linear-gradient(
      white 5%, #f3dada 10%, #f3dada 90%, white 95%
    );
  }
</style>
